<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="category-list">
        <div class="header-search">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="页面路径">
              <el-input v-model="formInline.link" placeholder="页面路径"></el-input>
            </el-form-item>
            <el-form-item label="页面名称">
              <el-input v-model="formInline.title" placeholder="页面名称"></el-input>
            </el-form-item>
            <el-form-item label="所属应用">
              <el-select v-model="formInline.source" placeholder="请选择所属应用">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <header style="display: flex;">
          <h3>页面列表</h3>
          <el-button v-if="myCount == 15167112912" size="small" type="primary" class="add-btn" @click="popAddBox('add')">新增页面</el-button>
        </header>
        <!-- 分类列表 -->
        <el-table
            v-loading="tableLoading"
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              prop="source_name"
              label="应用名称">
          </el-table-column>

          <el-table-column
              prop="title"
              label="页面名称">
          </el-table-column>

          <el-table-column
              width="300"
              prop="link"
              label="页面路径">
          </el-table-column>

          <el-table-column
              prop="params"
              label="页面参数">
          </el-table-column>

          <el-table-column
              width="200"
              prop="description"
              label="描述">
          </el-table-column>

          <el-table-column
              label="操作"
              width="120"
              v-if="myCount == 15167112912"
          >
            <template slot-scope="scope">
              <el-button v-show="scope.row.sort_name != '默认分类'" @click="popDelBox(scope.row)" type="text"
                         size="small">删除
              </el-button>
              <el-button v-show="scope.row.sort_name != '默认分类'" type="text" size="small"
                         @click="popAddBox('edit', scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagation" v-show="tableData.length > 0">
          <el-pagination
              layout="total, prev, pager, next"
              :total="page.totalCount"
              :page-size='page.pageSize'
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>


      <!-- 删除分类 -->
      <el-dialog
          :visible.sync="delBox"
          :before-close="handleDelCancel"
          title="删除页面"
          width="50%">
        <p class="title">删除页面后该页面无法在链接配置中选择！</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleDelCancel">取 消</el-button>
          <el-button type="primary" @click="handleDel">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 新增、编辑分类弹框 -->
      <el-dialog
          :visible.sync="dialogVisible"
          :before-close="handleCancel"
          width="50%">
        <div slot="title">{{ title }}</div>

        <el-form label-position="left" label-width="80px" ref="form" :model="LinkForm" :rules="rules">
          <el-form-item label="应用" prop="source">
            <el-select @change="selectSourceName" v-model="LinkForm.source" placeholder="请选择所属应用">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="页面名称" prop="title">
            <el-input maxlength=50 minlength=1 v-model="LinkForm.title" placeholder="页面名称"></el-input>
          </el-form-item>
          <el-form-item label="页面路径" prop="link">
            <el-input maxlength=200 minlength=1 v-model="LinkForm.link" placeholder="页面路径"></el-input>
          </el-form-item>
          <el-form-item label="页面参数">
            <el-input maxlength=200 minlength=1 v-model="LinkForm.params" placeholder="页面参数示例：a=xxx&b=xxx"></el-input>
          </el-form-item>
          <el-form-item label="页面描述">
            <el-input maxlength=200 minlength=1 v-model="LinkForm.description" placeholder="页面描述"></el-input>
          </el-form-item>
          <el-form-item label="页面ID">
            <el-input maxlength=200 minlength=1 v-model="LinkForm.page_id" placeholder="页面ID"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCancel">取 消</el-button>
                    <el-button type="primary" @click="addForm">确 定</el-button>
                </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import {Message, Loading} from 'element-ui';
import Common from "../picture/assets/scripts/common";
export default {
  name: 'routerLink',
  data() {
    return {
      tableData: [],
      setTableData: [],
      dialogVisible: false,
      handleType: '', //操作分类的类型 'add'新增分类 'edit'编辑分类
      title: '',
      delBox: false,
      delData: {},
      tableLoading: true,
      myCount:lib.cookie.get('mobile'),
      formInline: {
        link: '',
        title: '',
        source: ''
      },

      options: [{
        value: '6',
        label: '家家星选小程序'
      },{
        value: '1',
        label: '魔筷商家版APP'
      }, {
        value: '2',
        label: '企鹅小店商家版APP'
      }, {
        value: '3',
        label: '买家版APP'
      }, {
        value: '4',
        label: '星选小程序'
      }, {
        value: '5',
        label: '企鹅小店h5'
      }],
      LinkForm: {
        source: null,
        link: null,
        title: null,
        source_name: null,
        params: null,
        description: null,
      },
      rules: {
        source: [
          {required: true, message: '请选择所属应用', trigger: 'change'}
        ],
        title: [
          {required: true, message: '请输入页面名称', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        link: [
          {required: true, message: '请输入页面路径', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
      },

      page: {
        pageNumber: 1,
        pageSize: 20,
        pageCount: 20,
        currentPage: 0,
        totalCount: 0
      },
    }
  },
  mounted() {
    this.getLinkList('get');
  },
  methods: {
    handleSizeChange: function (val) {
      console.log(val,1)
    },
    handleCurrentChange: function (val) {
      this.page.currentPage = val-1;
      this.getLinkList(val);
    },
    onSearch: function (){
      this.page.currentPage = 0;
      this.getLinkList('search');
    },
    addForm(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.handleLink();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //新增/编辑 页面配置
    handleLink() {
      let that = this;
      let handleType = this.handleType;
      if (handleType == 'add' || handleType == 'edit') {
        lib.tmsapi.post({
          api: 'api/test/router/add',
          data: this.LinkForm,
          success: (res) => {
            // 提示成功
            Message.success({
              message: handleType == 'add' ? '添加页面成功' : '修改页面成功',
              type: 'info',
              center: true
            });
            this.resetForm();
            // 添加成功，刷新列表
            that.getLinkList('update');

            // 关闭弹框
            that.dialogVisible = false;
          },
        })
      }
    },
    // dialog取消按钮更改状态
    handleCancel: function () {
      this.dialogVisible = false;
      this.handleType = '';
      this.resetForm();
    },
    resetForm: function () {
      this.LinkForm = {
        source: null,
        link: null,
        title: null,
        source_name: null,
        params: null,
        description: null,
      }
    },
    // 点击新增/编辑弹框
    popAddBox: function (type, data) {
      if (!this.dialogVisible) {
        this.dialogVisible = true;
        this.handleType = type;
      }

      if (type == "edit") {
        this.title = "编辑页面";
        this.LinkForm = data;
      }

      if (type == "add") {
        this.title = "新增页面";
      }
    },

    // 获取分类列表
    getLinkList: function (type) {
      let params = {
        page: this.page.currentPage,
        count: this.page.pageSize,
      }
      params.source = this.formInline.source;
      params.link = this.formInline.link;
      params.title = this.formInline.title;
      lib.tmsapi.get({
        api: 'api/test/router/list',
        data: params,
        success: (res) => {
          if (res.data) {
            this.tableLoading = false;
            this.tableData = res.data || [];
            this.page.totalCount = res.total;
          }
        },
      })

    },

    // 点击删除弹框
    popDelBox: function (data) {
      if (!this.delBox) {
        this.delData = {...data};
        this.delBox = true;
      }
    }
    ,
    // 取消删除
    handleDelCancel: function () {
      this.delBox = false;
      this.delData = {};
    }
    ,
    // 删除一条分类
    handleDel: function (data) {
      let that = this;
      let linkId = this.delData.id;
      let params = {
        id: linkId
      };
      if (!linkId) {
        return false;
      }

      lib.tmsapi.post({
        api: 'api/test/router/del',
        data: params,
        success: (res) => {
          // 关闭弹框
          that.delBox = false;
          Message.success({
            message: '删除页面成功',
            type: 'info',
            center: true
          });
          // 添加成功，刷新列表
          that.getLinkList('update');
        },
      })

    }
    ,

    // 时间戳格式化
    timeFormat: function (date) {
      return Common.formatTime(date);
    },
    // 时间戳格式化
    selectSourceName: function (val) {
      this.options.forEach((item) => {
        if (item.value == val) {
          this.LinkForm.source_name = item.label;
        }
      })
    }
  },
}
</script>
<style scoped>
.wrapper{
  padding: 20px;
  background-color: #fff;
  margin: 20px;
}
.content-wrapper {
  margin: 20px auto;
  width: 100%;
}

.title {
  text-align: center;
  font-size: 16px;
}

.tips {
  font-size: 12px;
  padding-top: 10px;
  line-height: 18px;
  color: rgb(64, 158, 255);
}

.category-list header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-list header h3 {
  flex: 1;
}

.category-manage {
  margin-top: 30px;
}

.category-manage header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-manage small {
  font-size: 12px;
  color: #bbb;
  padding-left: 5px;
}

.category-manage .radio-button {
  margin: 0 10px 10px 10px;
  width: 150px;
  text-align: center;

}
</style>

